import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { BuisnessPromotion, ServiceList, ServiceTemplate } from 'src/app/models/common';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from '../../constants/sm-constants';
import { FormControl } from '@angular/forms';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../providers/shared.service';

@Component({
  selector: 'sm-add-service-templates',
  templateUrl: './add-service-templates.component.html',
  styleUrls: ['./add-service-templates.component.scss']
})
export class AddServiceTemplatesComponent implements OnInit {

  public serviceListData: ServiceTemplate = new ServiceTemplate();
  // isDiscount!: boolean;
  // isShop: boolean = false
  // isHome: boolean = false
  // isPercent!: boolean
  // isAmount!: boolean
  // isHomeSpecific: Boolean = false;
  // isShopSpecific: Boolean = false;
  // entityHash: string = '';
  // hideRequiredControl = new FormControl(false);
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public loader: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    public dialog: MatDialogRef<AddServiceTemplatesComponent>
  ) {}
  removeAsset() {
    this.serviceListData.imgUrl = '';
    this.assetList = [];
  }
  ngOnInit(): void {
    // console.log(this.isDiscount);
    // console.log(this.isPercent);
    
    
    // console.log(this.parentData.data);
    // this.route.queryParams.subscribe(data => {
    //   console.log(data.entityHash);
    //   this.entityHash = data.entityHash

      
    // })
    let data: any = new ServiceTemplate();
    Object.assign(data, this.parentData.data);
    console.log(data);
    if (data.hash_id) {
      this.assetList.push({
        assetName: data?.imgUrl
          .split('/')
          .pop()
          .substring(data.imgUrl.split('/').pop().lastIndexOf('_') + 1),
        url: data?.imgUrl,
      });
      this.serviceListData = data;
      this.editMode = true;
    }
    // if(data.shopStatus == 1){
    //   this.isShop = true
    //   let eve = {
    //     checked: true,
    //     source: {
    //       value: 'shop'
    //     }
    //   }
    //   this.change(eve);
    // }
    // if(data.homeStatus == 1){
    //   this.isHome = true
    //   let eve = {
    //     checked: true,
    //     source: {
    //       value: 'home'
    //     }
    //   }
    //   this.change(eve);
    // }
    // if(data.discountStatus ==1){
    //   this.isDiscount = true
    // }
    // if(data.discountStatus == 0 ){
    //   this.isDiscount = false
    // } 
    // if(data.discountType == 2 ){
    //   this.isAmount = true
    // }
    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        console.log(res.result);
        this.assetList.push({
          assetName: this.fileName,
          url: res.result?.url,
          thumbnail: res.result?.thumbnail,
        });
        this.serviceListData.imgUrl = res.result?.url;
        this.loader = false;
      }
      if (
        res.responseType === SM_CONSTANTS.UPDATE_BUISNESS_PROMOTION_INFO_RESULT
      ) {
        if (data) {
          this._snackBar.open('Buisness promo updated successfully', 'Ok', {
            duration: 3000,
          });
        } else {
          this._snackBar.open('Buisness promo added successfully', 'Ok', {
            duration: 3000,
          });
        }
        this.parentData.ref.closeAll();
      }
    });
  }
  // change(event:any){
  //   console.log(event);
  //   if(event.checked == true && event.source.value == 'home'){
  //     this.isHomeSpecific = true
  //     this.serviceListData.homeStatus = 1
  //   } if(event.checked == true && event.source.value == 'shop'){
  //     this.isShopSpecific = true
  //     this.serviceListData.shopStatus = 1
  //   } if(event.checked == false && event.source.value == 'home'){
  //     this.isHomeSpecific = false
  //     this.serviceListData.homeStatus = 0
  //     this.serviceListData.home_rate = null
  //     this.serviceListData.homeDiscountedPrice = null
  //   }if(event.checked == false && event.source.value == 'shop'){
  //     this.isShopSpecific = false
  //     this.serviceListData.shopStatus = 0
  //     this.serviceListData.shop_rate = null
  //     this.serviceListData.shopDiscountedPrice = null
  //   }
    
  // }

  // onApp(event:any){

  //   if(event.target.value == 'applicable' ){
  //     this.serviceListData.discountStatus = 1
  //   }if(event.target.value == 'not-applicable'){
  //     this.serviceListData.discountStatus = 0
  //     this.serviceListData.discountAmount = null
  //     this.serviceListData.discountType = null
  //     this.isPercent = false
  //     this.isAmount = false
  //     this.serviceListData.homeDiscountedPrice = null
  //     this.serviceListData.shopDiscountedPrice = null
  //   }

  // }

  // discType(event:any){
  //   if(event.target.value == 'percent' ){
  //     this.serviceListData.discountType = 1
  //   }if(event.target.value == 'amount'){
  //     this.serviceListData.discountType = 2
  //   }

  // }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
  }

  onPost() {
    // console.log('Data', this.serviceListData);
 
    console.log(this.editMode);
    if (!this.editMode) {
      // this.serviceListData['hash_id'] = undefined;
    }

    // if(this.serviceListData.discountType == 1){
    //   if(this.serviceListData.homeStatus != 0){
    //     this.serviceListData.homeDiscountedPrice = this.serviceListData.home_rate - (this.serviceListData.discountAmount/100)*this.serviceListData.home_rate
    //   }
    //   if(this.serviceListData.shopStatus != 0){
    //     this.serviceListData.shopDiscountedPrice = this.serviceListData.shop_rate - (this.serviceListData.discountAmount/100)*this.serviceListData.shop_rate
    //   }
      
    // }else if(this.serviceListData.discountType == 2){
    //   if(this.serviceListData.homeStatus != 0){
    //     this.serviceListData.homeDiscountedPrice = this.serviceListData.home_rate - this.serviceListData.discountAmount
    //   }
    //   if(this.serviceListData.shopStatus != 0){
    //     this.serviceListData.shopDiscountedPrice = this.serviceListData.shop_rate - this.serviceListData.discountAmount
    //   }
      
     
    // }
    if(this.serviceListData.home_rate == null || this.serviceListData.home_rate == '-' ){
      this.serviceListData.home_rate = 0
    }
    if(this.serviceListData.shop_rate == null || this.serviceListData.shop_rate == '-'){
      this.serviceListData.shop_rate = 0
    }
    


    Object.keys(this.serviceListData).forEach(key => {
      if ((this.serviceListData as any)[key] === null) {
        delete (this.serviceListData as any)[key];
      }
    });
  
 let bodydata = {
  serviceTypeInfo: this.serviceListData
 }
    console.log('updated data', bodydata);
    this._apiService.addServiceTemplate(bodydata)
    this.dialog.close();
      setTimeout(() => {
        this.sharedService.sendClickEvent();
      }, 2000);
    // this._apiService.updateBuisnessPromotion({
    //   promotionInfo: this.serviceListData,
    // });
  }

  onUploadImage(event: any) {
    this.loader = true;
    console.log(event.target.files);
    if (event.target.value === '') {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;
    let sizeinKb = +event.target.files[0].size / 1000;
    if (sizeinKb > 1021) {
      this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
      return;
    }
    let formData: FormData = new FormData();
    formData.append('recfile', event.target.files[0]);
    this._apiService.uploadAssets(formData, 1);
  }

  // locationAutoComplete(event: any) {
  //   console.log('location', event.place.address_components);
  //   // administrative_area_level_1 = state
  //   // locality = city
  //   // country = country
  //   event.place.address_components?.forEach((data: any) => {
  //     let type = data.types[0];
  //     console.log(type);
  //     if (type === 'administrative_area_level_1') {
  //       this.serviceListData.targetState = data?.long_name;
  //     } else if (type === 'locality') {
  //       this.serviceListData.targetCity = data.long_name;
  //     } else if (type === 'country') {
  //       this.serviceListData.targetCountry = data.long_name;
  //     }
  //   });
  // }

}
